<template>
  <div>
    <div class="topDiv">
      <span>是否打印所有内容？</span>
      <el-button @click="goBack">返 回</el-button>
      <el-button type="primary" v-print="printObj">打 印</el-button>
    </div>
    <div class="printContract">
      <div class="contentPrint" id="printContract">
        <div class="title">租金月度汇总表</div>
        <div style="margin-top: .1rem">
        <el-table
            v-loading="loading"
            :data="tableDataSum"
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false"
            :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <template v-for="(item, index) in tableSumColumns">
            <el-table-column
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width">
            </el-table-column>
          </template>
        </el-table>
        </div>
        <div style="margin-top: 1rem">
          <el-table
              v-loading="loading"
              :data="tableData"
              :default-sort = "{prop: 'id', order: 'descending'}"
              style="width: 100%"
              :highlight-current-row="false"
              :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
            <template v-for="(item, index) in tableColumns">
              <el-table-column
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  :width="item.width">
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryExcelMonthSummary, queryExcelMonthBuilding } from '@/api/statistics'

export default {
  name: 'printHouseRent',
  data () {
    return {
      loading: false,
      printObj: {
        id: 'printContract',
        popTitle: '打印',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      yearValue: this.$route.query.yearValue,
      tableDataSum: [
        {}
      ],
      tableSumColumns: [
        {
          prop: 'statisticsMonth',
          label: '年月'
        },
        {
          prop: 'curMonthInvoice',
          label: '当月开票数（万元）'
        },
        {
          prop: 'accumulatedInvoice',
          label: '累计开票数（万元）'
        },
        {
          prop: 'accumulatedReceivables',
          label: '累计应收账（万元）'
        },
        {
          prop: 'accumulatedNoInvoice',
          label: '累计未开票（万元）'
        },
        {
          prop: 'accumulatedCollectionRate',
          label: '累计收缴率'
        }
      ],
      tableData: [],
      tableColumns: [
        {
          prop: 'statisticsMonth',
          label: '年月',
          width: 100
        },
        {
          prop: 'buildingName',
          label: '楼宇'
        },
        {
          prop: 'tenantName',
          label: '租赁名称'
        },
        {
          prop: 'rentalArea',
          label: '面积（㎡）',
          width: 100
        },
        {
          prop: 'daliyRental',
          label: '租金单价（元）',
          width: 120
        },
        {
          prop: 'annualRental',
          label: '年租金（元）',
          width: 110
        },
        {
          prop: 'securityDeposit',
          label: '保证金（元）',
          width: 110
        },
        {
          prop: 'contractPeriod',
          label: '合同期(整数月)',
          width: 110
        },
        {
          prop: 'invoiceDate',
          label: '本期开票日'
        },
        {
          prop: 'rentRemindRemark',
          label: '租金是否到位/提醒'
        }
      ]
    }
  },
  components: {},
  mounted () {
    this.queryListSum()
    this.queryList()
  },
  methods: {
    // 查询累计信息
    async queryListSum () {
      let res = await queryExcelMonthSummary({
        statisticsMonth: this.yearValue
      })
      if (res.code === 0) {
        this.tableDataSum = res.result.records
      }
    },
    // 查询
    async queryList () {
      let res = await queryExcelMonthBuilding({
        statisticsMonth: this.yearValue
      })
      if (res.code === 0) {
        this.tableData = res.result.records
      }
    },
    // 取消
    goBack () {
      this.$router.push('/report/houseRent')
    }
  }
}
</script>

<style lang="scss" scoped>
  .topDiv{
    padding-left: .6rem;
    width: 10rem;
    margin: .25rem auto;
    font-size: .16rem;
    letter-spacing: .03rem;
  }
  .printContract{
    margin: 0 auto;
    width: 61%;
    /*background-color: #fff;*/
    .contentPrint{
      width: 100%;
      .title{
        letter-spacing: .03rem;
        font-size: .16rem;
        margin-bottom: .1rem;
        margin-top: .2rem;
      }
    }
  }

  /deep/.el-table td{
    text-align:center !important
  }

</style>
